<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <v-tour name="blogisticTour" :steps="steps" :callbacks="callbacksTour"></v-tour>
                            <h4 class="card-title">Gerar Siscarga</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div>
                                <b-row no-gutters>
                                    <b-col>
                                        <multiselect v-model="form.termembarque"
                                        :options="optionsTerminalEmb"
                                        track-by="value"
                                        label="label"
                                        :hide-selected="true"
                                        placeholder="Terminal de Embarque"
                                        tag-placeholder="Selecionar"
                                        select-label="Selecionar"
                                        selected-label="Selecionado"
                                        deselect-label="Remover"
                                        ></multiselect>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('termembarque.value')" v-if="form.errors.has('termembarque.value')"></b-form-feedback>
                                    </b-col>
                                    <b-col>
                                        <multiselect v-model="form.termdesembarque"
                                        :options="optionsTerminalDes"
                                        track-by="value"
                                        label="label"
                                        :hide-selected="true"
                                        placeholder="Terminal de Desembarque"
                                        tag-placeholder="Selecionar"
                                        select-label="Selecionar"
                                        selected-label="Selecionado"
                                        deselect-label="Remover"
                                        ></multiselect>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('termdesembarque.value')" v-if="form.errors.has('termdesembarque.value')"></b-form-feedback>
                                      </form>
                                  </b-col>
                                  <b-col>
                                      <div class="fl-flex-label fl-collapsed fl-background">
                                          <input type="text" class="form-control" v-model="form.navio_viagem" @keyup.enter="doFilter">
                                          <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Navio - Viagem</label>
                                      </div>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('navio_viagem')" v-if="form.errors.has('navio_viagem')"></b-form-feedback>
                                  </b-col>
                                  <b-col>
                                      <div class="fl-flex-label fl-collapsed fl-background">
                                          <input type="text" class="form-control" v-model="form.cnpj_agencia" @keyup.enter="doFilter">
                                          <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">CNPJ Agência</label>
                                      </div>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('cnpj_agencia')" v-if="form.errors.has('cnpj_agencia')"></b-form-feedback>
                                  </b-col>
                                  <b-col>
                                      <b-btn @click="handleOk($event)" variant="primary" :disabled="isDisabled">
                                        Gerar Siscarga
                                      </b-btn>
                                  </b-col>
                              </b-row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import SiscargaFilterBar from './SiscargaFilterBar'
import moment from 'moment'
import accounting from 'accounting'

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        'vuetable-filterbar': SiscargaFilterBar
    },
    data () {
        return {
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          loading: false,
          isDisabled: false,
          loadingData: true,
          showModal: false,
          isFullscreen: false,
          optionsTerminalEmb: [],
          optionsTerminalDes: [],
          doc_id: '',
          helpForm: new Form({statusRecord: [], params: []}),
          form: new Form({
              termembarque: '',
              termdesembarque: '',
              navio_viagem: '',
              cnpj_agencia: ''
                }),
          fields: [
            {
                name: '__checkbox',
                titleClass: 'center aligned',
                dataClass: 'center aligned'
            },
            {
              name: 'doc_cte.doc_cte_aqua.num_controle',
              title: 'Nº Controle'
            },
            {
                name: 'num_fiscal',
                title: 'CTE'
            },
            {
              name: 'status.descr',
              title: 'Status Documento'
            },
            {
              name: 'doc_cte.status_sefaz.descr',
              title: 'Status Sefaz'
            },
            {
              name: 'dt_emi',
              title: 'Data Emissão',
              callback: 'formatDate|DD/MM/YYYY h:mm:ss'
            },
            {
              name: 'doc_cte.doc_cte_aqua.embarcacao.cd',
              title: 'Navio'
            },
            {
              name: 'doc_cte.doc_cte_aqua.num_viagem',
              title: 'Viagem'
            },
            {
              name: 'doc_cte.doc_cte_aqua.porto_embarque.nome',
              title: 'Porto de Embarque'
            },
            {
              name: 'doc_cte.doc_cte_aqua.porto_destino.nome',
              title: 'Porto de Destino'
            },
            {
              name: 'doc_cte_partes_env.tom_nome',
              title: 'Tomador'
            }
        ],
        css: {
            tableClass: 'table table-striped',
            loadingClass: 'loading',
            ascendingIcon: 'glyphicon glyphicon-chevron-up',
            descendingIcon: 'glyphicon glyphicon-chevron-down',
            handleIcon: 'glyphicon glyphicon-menu-hamburger',
        },
        moreParams: {}
       }
    },
    mounted() {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
        this.getTerminal();
      },
    methods: {
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)
        },
        onFilterSet (data_filter) {
            this.loadingData = true;
            this.moreParams = {
                'navio_viagem': data_filter.filterTextNavioViagem,
                'porto_destino': data_filter.filterTextPortoDestino.value,
                'porto_origem': data_filter.filterTextPortoOrigem.value
            }
            Vue.nextTick( () => this.$refs.vuetable.reload())
        },
        onFilterReset () {
            this.loadingData = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterShowHide() {
            if(this.vuetableFilterRow)
            {
                this.$store.commit('setVuetableFilterRow', false);
            }
            else
            {
                this.$store.commit('setVuetableFilterRow', true);
            }
        },
        onLoaded: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingData = false;
            this.$store.commit('setVuetableFilterButton', false);
        },
        formatDate (value, fmt = 'D MMM YYYY') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY-MM-DD').format(fmt)
        },
        formatNumber (value) {
            return accounting.formatNumber(value, 2, '.', ',')
        },
        handleOk(e)
        {
            e.preventDefault();
            this.onStore();

        },
        expandFullscreen() {
            this.isFullscreen = !this.isFullscreen;
        },
        onCreate (data) {
            this.modal_titulo = "Gerar Siscarga";
            this.modal_botao = "Gerar Siscarga";
            this.modal_acao = "i";
            this.form.reset();
            this.form.doc_id = [];
            this.$refs.vuetable.selectedTo.forEach((obj)=>{
                this.form.doc_id.push({ id: obj })
            });
            this.$refs.modal_form.show();
        },
        onStore() {
            this.loading = true;
            this.isDisabled = true;
            this.form.post('/api/siscarga/gerar').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        getTerminal() {
            this.form.get('/api/porto/terminal/jsonlist').then(response =>
            {
                new ReturnApi(response, this)
                response.items.forEach((obj)=>{
                    this.optionsTerminalEmb.push({ label: obj.cd+" - "+obj.descr, value: obj.terminal_id });
                    this.optionsTerminalDes.push({ label: obj.cd+" - "+obj.descr, value: obj.terminal_id });
                });
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
    },
    computed: {
        vuetableFilterRow: {
            get () {
                return this.$store.getters.vuetable.filterRow;
            },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
}
</script>
